import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGroup } from "../redux/actions";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import presentacionDfVideo from "../assets/avatares/timeup.mp4";
import { useVideoWithSound } from "../hooks/useVideoWithSound";
import Scenario2NextCta from "./Scenario2/Scenario2NextCta";
import "./StartGame.css";

const ACTIVE_SCENARIO_FOR_FINAL = 5;

function Gameover() {
	const dispatch = useDispatch();
	const group = useSelector((state) => state.group);

	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 0.8,
	});

	useEffect(() => {
		if (group) {
			dispatch(
				setGroup({
					...group,
					lastVisited: ROUTES.GAMEOVER,
					finished: true,
				})
			);
			updateStats({
				...group,
				lastVisited: ROUTES.GAMEOVER,
				finished: true,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- sincronizar cierre una vez al montar
	}, []);

	return (
		<div className="start-game-page start-game-page--welcome">
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Tiempo de juego
						</span>
						<div className="start-game-avatar-wrap">
							<div className="start-game-avatar-inner">
								<video
									ref={videoRef}
									autoPlay
									muted={!canPlayWithSound}
									playsInline
									preload="auto"
									aria-label="Presentación visual"
								>
									<source src={presentacionDfVideo} type="video/mp4" />
								</video>
							</div>
						</div>
					</div>
					<div className="start-game-panel">
						<h1 className="start-game-title">
							<span className="start-game-title-accent">Tiempo agotado</span>
						</h1>
						<p className="start-game-lead">
							¡Oh no! ¡El tiempo se ha agotado!
						</p>
						<p className="start-game-lead">
							No obstante, con el capital que has obtenido, puedes pasar a la fase final.
						</p>
						<div className="start-game-footer">
							<Scenario2NextCta
								navigateTo={ROUTES.SCENARIO5_QUIZ1}
								activeScenario={ACTIVE_SCENARIO_FOR_FINAL}
								label="Ir a la fase final"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Gameover;
